import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ConnectionCard } from '@feathr/components';

import type { IInstagramAccount } from '../MetaConnectedView.hooks';

interface IMetaInstagramAccountsCardProps {
  accounts: IInstagramAccount[];
}

function MetaInstagramAccountsCard({
  accounts,
}: Readonly<IMetaInstagramAccountsCardProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <ConnectionCard name={'meta-instagram-accounts-card'}>
      <ConnectionCard.Header count={accounts.length} icon={faInstagram} iconTheme={'pink'}>
        {t('Instagram Accounts')}
      </ConnectionCard.Header>
      <ConnectionCard.Items>
        {accounts.map((account) => (
          <ConnectionCard.Item href={account.url} key={account.id}>
            {account.username}
          </ConnectionCard.Item>
        ))}
      </ConnectionCard.Items>
    </ConnectionCard>
  );
}

export default MetaInstagramAccountsCard;
